import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getNewsApiUrl,
  getNewsApiKey,
  getHeaderForAjax,
} from "./ServiceHelper";
import { checkSettingData } from "./PublicService";
import { getLoggedInUser, getSelectedSubUser } from "./AuthenticationService";
import { I18n } from "react-i18next";
import moment from "moment";
import i18n from "../i18n";

export function getStocks(subUser) {
  var result = JSON.parse(localStorage.getItem("lastUpdateSyptoms"));
  let user = {};
  if (subUser) {
    user = subUser;
  } else {
    user = JSON.parse(localStorage.getItem("user"));
  }

  if (result.Data) {
    result = result.Data.filter((item) => {
      return item.participant == user._id;
    });
  }


  if (result && result.length > 0) {
    result = result[0].Symptoms.map((item) => {
      item.order = parseInt(item.order);
      return item;
    });
    result = _.orderBy(result, ["visibility", "order"], ["desc", "asc"]);
  } else
    return {
      data: [],
      currentUser: user,
    };

  return {
    data: result,
    currentUser: user,
  };
}

export function addNewOrdering(data, user) {
  var sendingData = {
    user: user._id,
    data: [],
  };
  var visibility = true;
  sendingData.data = data.map((item, index) => {
    if (item.type && item.type == "seprator") {
      visibility = false;
    }
    let order = index;
    if (!visibility) {
      --order;
    }
    if (!item.type || item.type != "seprator")
      return {
        _id: item._id,
        symptom: item.symptom,
        visibility: visibility,
        order: order,
      };
  });
  sendingData.data = sendingData.data.filter((item) => item != undefined);

  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/users/" + userId + "/response/viewsummaryorder/";
  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(sendingData),
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function deleteStock(_id) {
  const userId = getLoggedInUser()._id;

  return fetch(getApiUrl() + "/users/" + userId + "/symptoms_uncheck/" + _id, {
    method: "get",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then((res) => {
      return { _id: _id };
    })
    .catch((error) => console.log(error));
}

export function addStock(_id) {
  const userId = getLoggedInUser()._id;

  return fetch(getApiUrl() + "/users/" + userId + "/symptoms_check/" + _id, {
    method: "get",
  })
    .then(checkStatus)
    .then((res) => {
      return { _id: _id };
    })
    .catch((error) => console.log(error));
}

export function getdetailStocks() {
  var baseUser = localStorage.getItem("user");
  let user = JSON.parse(baseUser);
  var lastUpdateSyptom = localStorage.getItem("lastUpdateSyptoms");
  var lastTime = "";
  if (lastUpdateSyptom) {
    lastUpdateSyptom = JSON.parse(lastUpdateSyptom);
    lastTime = lastUpdateSyptom.lastdate;
  } else {
    lastTime = "";
  }
  lastTime = lastTime || "";
  let url = `${getApiUrl()}/users/${user._id
    }/response/viewsummary/?lastupdate=${lastTime}`;
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(async (res) => {
      var status = res.status;
      var result = {};
      if (status == 200) {
        result = await res.json();
        localStorage.setItem("lastUpdateSyptoms", JSON.stringify(result));
      } else if (status == 201) {
        result = JSON.parse(localStorage.getItem("lastUpdateSyptoms"));
      }
      if (result.Data && result.Data.length > 0) {
        return result;
      } else {
        return new Error("Problem in data");
      }
    })
    .catch((ex) => {
      return {
        data: [],
      };
    });
}

export function getFoodGragh(factorId, _id, time, startTime, subUser) {
  if (!_id) {
    return [];
  }
  //#region time handeling
  var start = moment(startTime).startOf("day") || moment().startOf("day");
  let end = moment().endOf("day"); //Date.now();
  // start.set({ h: 0, m: 0, s: 0 });
  if (startTime) {
    if (time == "1W") {
      end = moment(startTime).add(1, "week").unix() * 1000;
      // alert(end);
    } else if (time == "2W") {
      end = moment(startTime).add(2, "weeks").unix() * 1000;
    } else if (time == "1M") {
      end = moment(startTime).add(1, "months").unix() * 1000;
    } else if (time == "3M") {
      end = moment(startTime).add(3, "months").unix() * 1000;
    } else if (time == "6M") {
      end = moment(startTime).add(6, "months").unix() * 1000;
    } else if (time == "1Y") {
      end = moment(startTime).add(1, "year").unix() * 1000;
    } else if (time == "2Y") {
      end = moment(startTime).add(2, "years").unix() * 1000;
    } else if (time == "5Y") {
      end = moment(startTime).add(5, "year").unix() * 1000;
    }
  } else {
    //alert(time);
    if (time == "1D") {
      start.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      start = start.unix() * 1000;
    } else if (time == "1W") start = moment(end).add(-1, "week").unix() * 1000;
    else if (time == "1M") start = moment(end).add(-1, "months").unix() * 1000;
    else if (time == "3M") start = moment(end).add(-3, "months").unix() * 1000;
    else if (time == "6M") start = moment(end).add(-6, "months").unix() * 1000;
    else if (time == "1Y") start = moment(end).add(-1, "year").unix() * 1000;
    else start = end - 2 * 12 * 30 * 86400 * 1000;
  }

  //#endregion
  start = moment(start).startOf("day");
  end = moment(end).endOf("day");
  const userId = getLoggedInUser()._id;
  subUser = subUser || userId;
  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/graph/" +
    factorId +
    "/?start=" +
    start +
    "&end=" +
    end +
    "&participant=" +
    subUser +
    "&item=" +
    _id;

  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      let data = res.items.map((item, key) => {
        return {
          // x: moment(item.date),
          ...item,
          x: moment(Number(item.date.$numberLong)),
          y: item.value,
          items: item.items,
        };
      });
      return data;
    })
    .catch((err) => {
      console.log(
        "StockService::getStockGraph(), ERROR:" + JSON.stringify(err)
      );
      return [];
    });
}

export function getStockGraph(_id, time, startTime, subUser) {
  if (!_id) {
    return [];
  }
  //#region time handeling
  var start = moment(startTime).startOf("day") || moment().startOf("day");
  let end = moment().endOf("day");
  if (startTime) {
    startTime = moment(startTime).startOf("day");
    if (time == "1W") {
      end = moment(startTime).add(1, "week").unix() * 1000;
    } else if (time == "2W") {
      end = moment(startTime).add(2, "weeks").unix() * 1000;
    } else if (time == "1M") {
      end = moment(startTime).add(1, "months").unix() * 1000;
    } else if (time == "3M") {
      end = moment(startTime).add(3, "months").unix() * 1000;
    } else if (time == "6M") {
      end = moment(startTime).add(6, "months").unix() * 1000;
    } else if (time == "1Y") {
      end = moment(startTime).add(1, "year").unix() * 1000;
    } else if (time == "2Y") {
      end = moment(startTime).add(2, "years").unix() * 1000;
    } else if (time == "5Y") {
      end = moment(startTime).add(5, "year").unix() * 1000;
    }
  } else {
    //alert(time);
    if (time == "1D") {
      start.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      start = start.unix() * 1000;
    } else if (time == "1W") start = moment(end).add(-1, "week").unix() * 1000;
    else if (time == "1M") start = moment(end).add(-1, "months").unix() * 1000;
    else if (time == "3M") start = moment(end).add(-3, "months").unix() * 1000;
    else if (time == "6M") start = moment(end).add(-6, "months").unix() * 1000;
    else if (time == "1Y") start = moment(end).add(-1, "year").unix() * 1000;
    else start = end - 2 * 12 * 30 * 86400 * 1000;
  }

  //#endregion
  const userId = getLoggedInUser()._id;
  if (!subUser) {
    subUser = getSelectedSubUser();
    subUser = subUser ? subUser._id : userId;
  }
  end = moment(end).endOf("day");
  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/response/symptoms/graph/?start=" +
    start +
    "&end=" +
    end +
    "&participant=" +
    subUser +
    "&symptom=" +
    _id;
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      let data = res.map((item, key) => {
        let date = moment(item.date.$numberLong * 1000).unix();
        return {
          x: date,
          y: item.severity,
          unit: item.unit
        };
      });
      return data;
    })
    .catch((err) => {
      console.log(
        "StockService::getStockGraph(), ERROR:" + JSON.stringify(err)
      );
      return [];
    });
}

export function getStock(_id) {
  const userId = getLoggedInUser()._id;
  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/response/symptoms/graph/?start=0&end=" +
    Date.now() +
    "&participant=" +
    userId +
    "&symptom=" +
    _id;
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      res = _.sortBy(res, ["date"]).reverse();
      if (res.length > 2) res = res.slice(0, 2);
      let ids = [];
      let rlt = res[0];
      if (res.length > 1) {
        if (parseInt(res[0].severity) > parseInt(res[1].severity)) {
          rlt.state = 1;
        } else if (parseInt(res[0].severity) < parseInt(res[1].severity)) {
          rlt.state = -1;
        } else {
          rlt.state = 0;
        }
      } else {
        rlt.state = 0;
      }
      return rlt;
    });
}

export function getSymptomChart(data, type) {
  const userId = getLoggedInUser()._id;
  const start = new Date(data.start).getTime();
  const end = new Date(data.end).getTime();
  let url = "";
  if (type == "symptom")
    url =
      getApiUrl() +
      "/users/" +
      userId +
      "/response/symptoms/graph/?start=" +
      start +
      "&end=" +
      end +
      "&participant=" +
      data.user +
      "&symptom=" +
      data.symptom;
  else
    url =
      getApiUrl() +
      "/users/" +
      userId +
      "/response/meals/?start=" +
      start +
      "&end=" +
      end +
      "&participant=" +
      data.user +
      "&factor=" +
      data.factor;

  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      let total = 0;
      let data = res.map((item, key) => {
        if (type == "symptom")
          return {
            x: moment(item.date).format("YYYY-MM-DD HH:mm"),
            y: item.severity,
          };
        else {
          for (let i = 0; i < item.nutrients.length; i++)
            total += item.nutrients[i].size;
          return {
            x: moment(item.date).format("YYYY-MM-DD HH:mm"),
            y: parseInt(total),
          };
        }
      });
      return data;
    })
    .catch(() => {
      return [];
    });
}

export function getNews(name, trans) {
  let url =
    getNewsApiUrl() + "?q=" + trans + " " + name + "&apiKey=" + getNewsApiKey();
  return fetch(url, {
    method: "GET",
    dataType: "json",
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      return res.articles.splice(0, 10);
    })
    .catch(() => {
      return [];
    });
}

export async function getAllFactors(id) {
  let factors = i18n.t("ANALYZE_CAT", {
    returnObjects: true,
  });
  return factors;
  // var setting = await checkSettingData();
  // return setting.analyzecategories.map((item) => {
  //   return { value: item.code, label: item.name };
  // });
}
export function getNutrients(id, text, subUser, symptom) {
  const userId = getLoggedInUser()._id;
  let subId = subUser || userId;
  let url = "";

  // if (id == "03") {
  //   url = `${getApiUrl()}/users/${userId}/response/factorlist/${id}/${subId}?itemid=${symptom}`;
  // } else {
  //   url = `${getApiUrl()}/users/${userId}/response/factorlist/${id}/${subId}`;
  // }

  url = `${getApiUrl()}/users/${userId}/response/factorlist/${id}/${subId}?symptom=${symptom}`;

  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((data) => {
      // if (data && data.length < 1) {
      //   data.push({
      //     // _id: id,
      //     name: `${text} [THERE IS NOT IN OUR DATABASE]`,
      //   });
      // }
      var result = { id: id, data: data };
      return result;
    });
}

//have to remove
export function getFactors() {
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/meals/factors";
  return fetch(url, {
    method: "GET",
    dataType: "json",
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      let rlt = res.map((e) => {
        return { value: e._id, label: e.name };
      });
      return {
        data: rlt,
      };
    })
    .catch(() => {
      return {
        data: [],
      };
    });
}

export function getUsers() {
  const userId = getLoggedInUser()._id;
  return fetch(getApiUrl() + "/users/" + userId + "/subusers/", {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(parseJSON)
    .then((r) => {
      let data = [];
      data = r.map(function (e) {
        return {
          label: e.last_name + " " + e.first_name,
          value: e._id,
        };
      });
      return data;
    })
    .catch(function (err) {
      console.log("UserService::getSubUsers(), Error:" + err);
    });
}

export function getSymptoms() {
  let user = JSON.parse(localStorage.getItem("user"));
  let data = user.usersymptoms.filter((e) => {
    return e.visibility;
  });
  let rlt = data.map((e) => {
    return { value: e._id, label: e.name };
  });
  return {
    data: rlt,
  };
}
export function getGraphReport(optForm, exportOpt) {
  //{{server_url}}/users/{{user}}/reportanz_total/{symptom}?start=1646582400000&end=1649260800000&participant=04200000307&item=44280006441&data=true&graph=true&tfi=false&custom=true
  let userId = getLoggedInUser()._id;
  //#region time handeling
  var start = moment(startTime).startOf("day") || moment().startOf("day");
  let end = moment().endOf("day");
  let startTime = optForm.start;
  let time = optForm.end;
  if (startTime) {
    startTime = moment(startTime).startOf("day");
    if (time == "1W") {
      end = moment(startTime).add(1, "week").unix() * 1000;
    } else if (time == "2W") {
      end = moment(startTime).add(2, "weeks").unix() * 1000;
    } else if (time == "1M") {
      end = moment(startTime).add(1, "months").unix() * 1000;
    } else if (time == "3M") {
      end = moment(startTime).add(3, "months").unix() * 1000;
    } else if (time == "6M") {
      end = moment(startTime).add(6, "months").unix() * 1000;
    } else if (time == "1Y") {
      end = moment(startTime).add(1, "year").unix() * 1000;
    } else if (time == "2Y") {
      end = moment(startTime).add(2, "years").unix() * 1000;
    } else if (time == "5Y") {
      end = moment(startTime).add(5, "year").unix() * 1000;
    }
  }

  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/reportanz_total/" +
    optForm.symptom +
    "?start=" +
    startTime +
    "&end=" +
    end +
    "&participant=" +
    optForm.user +
    "&item=" +
    optForm.nutrients +
    "&data=" +
    exportOpt.data +
    "&graph=" +
    exportOpt.graph +
    "&tfi=" +
    exportOpt.tfi +
    "&custom=" +
    exportOpt.custom +
    "&category=" +
    optForm.factor;
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/services/StockService.js